import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import muiTheme from "./theme/muiTheme";
import "./theme/CssBaselineOverrides.css";
import Router from "./routes/Router";
import { CartProvider } from "./context/CartContext";
import { UIProvider } from "./context/UIContext";

const App = () => {
  return (
    <ThemeProvider theme={muiTheme}>
      <CssBaseline />
      <CartProvider>
        <UIProvider>
          <Router />
        </UIProvider>
      </CartProvider>
    </ThemeProvider>
  );
};

export default App;
